import React from "react";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import typeToView from "routing/typetoview";
import useHierarchy from "backend/hooks/elements/useHierarchy";
import Page from "design/pages/Page";
import DivisionGrid from "design/components/tables/DivisionGrid";
import ToolbarWithHeading from "components/toolbars/ToolbarWithHeading";
import useElement from "backend/hooks/elements/useElement";
import ToolbarWithMeasureName from "components/toolbars/ToolbarWithMeasureName";

const Division = () => {
  const ctx = useAppContext();
  const link = useLink();
  const {
    data,
    isLoading: isDataLoading,
    isError,
    isPreviousData,
    isRefetching,
  } = useHierarchy(ctx.elementId);

  const { data: element } = useElement(ctx.elementId);

  return (
    <Page
      isLoading={!data || isDataLoading || isRefetching || isPreviousData}
      Toolbar={ToolbarWithMeasureName}
    >
      {data ? (
        <DivisionGrid
          elements={data?.sort((a, b) => a.symbol.localeCompare(b.symbol))}
          onSelect={(el) => {
            link({ page: "StrategyMap", meaId: el.topelement });
          }}
        />
      ) : null}
    </Page>
  );
};
export default Division;
